(() => {
  const initialize = (content) => {
    const element = content.element;

    Array.from(element.querySelectorAll('a[target="_blank"]')).map((link) => {
      if (!link.hasAttribute('aria-label')) {
        link.setAttribute('aria-label', `${link.innerText} - new window`);
      }
    });
  };

  const content = stp.setup('content');

  content.map(initialize);
})();
